import {AxiosError} from 'axios'

export function isAxiosError(err: undefined | Error | AxiosError): err is AxiosError {
  return Boolean(err && 'isAxiosError' in err && err.isAxiosError)
}

export function isUnauthenticatedError(err: undefined | Error | AxiosError) {
  return isAxiosError(err) && err.response?.status === 401
}
